<template>
    <v-container>
        <h1 class="display-1">Create Character</h1>

        <v-card class="mt-4">
            <v-card-text>
                <v-text-field v-model="form.name"
                              @keydown.enter="storeCharacter"
                              label="Name"/>

                <v-radio-group v-model="form.character_class_id"
                               label="Class">

                    <div v-for="(characterClass, characterClassIndex) in classes" :key="characterClassIndex" class="mb-4">
                        <v-avatar size="32" class="mb-2 mr-2">
                            <v-img :src="getClassAvatar(characterClass)"/>
                        </v-avatar>
                        <v-radio class="d-inline" :label="characterClass.name" :value="characterClass.id"/>
                    </div>
                </v-radio-group>
                
                <v-select v-model="form.ancestor_id"
                          @keydown.enter="storeCharacter"
                          :items="ancestors"
                          item-text="name"
                          item-value="id"
                          clearable
                          label="Ancestor (optional)"/>
                <v-btn color="secondary"
                       @click="$router.push({name: 'party', params: {partyId: $route.params.partyId}})" class="mr-2">
                    Cancel
                </v-btn>
                <v-btn color="primary" @click="storeCharacter" :loading="loading">Create</v-btn>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import CharacterClassService from "../services/CharacterClassService";
  import CharacterService from "../services/CharacterService";
  import PartyService from "../services/PartyService";

  export default {
    data: () => ({
      loading: false,
      classes: [{
        id: null,
        name: null
      }],
      form: {
        name: null,
        character_class_id: null,
        ancestor_id: null
      },
      ancestors: []
    }),

    created() {
      this.indexClasses();
      this.availableAncestors();
    },

    methods: {
      indexClasses() {
        CharacterClassService.indexAvailableByParty(this.$route.params.partyId)
          .then(response => {
            this.classes = response.data.data;
          });
      },

      storeCharacter() {
        this.loading = true;
        this.form.party_id = this.$route.params.partyId;

        CharacterService.store(this.form)
          .then(() => {
            this.$router.push({name: 'party', params: {partyId: this.$route.params.partyId}});
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
          });
      },

      availableAncestors() {
        PartyService.availableAncestors(this.$route.params.partyId)
          .then(response => {
            this.ancestors = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },

      getClassAvatar(characterClass) {
        try {
          return require(`@/assets/${characterClass.slug}.png`);
        } catch (e) {
          return "";
        }
      }
    }
  };
</script>
